<template>
    <div>
        <banner heading="SHOPSHEADING" description="SHOPSDESCRIPTION" type="shop"></banner>
        <div class="container">
            <div class="input-group">
                <span class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-building"></i></span>
                </span>
                <select v-model="increment" @change="incrementChanged" class="form-control custom-select" id="change-increment" aria-label="Increment">
                    <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                </select>
            </div>
            <hr>
            <div class="row">
                <shop v-for="shop in shops" :key="shop.grade" :shop="shop" :progress="getProgressByShopID(shop)"></shop>
            </div>
        </div>
    </div>
</template>

<script>
import shopComponent from './Shop.vue';
import banner from './Banner.vue';
import { mapGetters } from 'vuex';

export default {
    name:     'shop-list',
    computed: {
        ...mapGetters({
            shops:    'allShops',
            progress: 'progress',
            byID:     'getShopByID'
        }),
        buildIncrement() {
            return this.$store.state.game.buildIncrement;
        }
    },
    methods:  {
        incrementChanged(e) {
            const newIncrement = parseInt(e.target.value, 10),
                store          = this.$store;
            store.dispatch('setBuildIncrement', newIncrement)
                .then(() => { store.dispatch('setMaxAmount', newIncrement); });
        },
        getProgressByShopID(shop) {
            const progress = this.progress.find(s => s.id === shop.id);
            return typeof progress !== 'undefined' ? progress : { progress: 0, remaining: shop.coolDown, id: shop.id };
        }
    },
    data() {
        // hack: work-around restoring the build-increment via vuex-persist
        const store  = this.$store,
            increment = this.$store.state.game.buildIncrement;
        // this should not be here.
        store.dispatch('setBuildIncrement', increment)
            .then(() => { store.dispatch('setMaxAmount', increment); });
        return {
            options:  [
                { text: 1, value: 1 },
                { text: 5, value: 5 },
                { text: 10, value: 10 },
                { text: 100, value: 100 },
                { text: 'max', value: -1 }
            ],
            increment: store.state.game.buildIncrement
        };
    },
    components: {
        shop: shopComponent,
        banner
    }
};
</script>
